import { MediaItem } from '../../models';
import { QualitySelectionRepresentation } from '../../plugin';

export abstract class VhsHandler {
    private _bandwidth: number;
    private _systemBandwidth: number;
    private _throughput: number;
    private _selectedPlaylist: MediaItem;

    abstract representations(): QualitySelectionRepresentation[];

    el?: HTMLElement;
    id_?: string;
    ignoreNextSeekingEvent_?: boolean;
    isDisposed_?: boolean;
    limitRenditionByPlayerDimensions?: boolean;
    useDevicePixelRation?: boolean;
    playlists?: MediaItem[];

    stats?: {
        timestamp?: number;
        mediaRequests?: number;
        mediaRequestsAborted?: number;
        mediaRequestsErrored?: number;
        mediaRequestsTimedOut?: number;
        mediaTransferDuration?: number;
        mediaBytesTransferred?: number;
        mediaSecondsLoaded?: number;
        currentSource?: {
            limitRenditionByPlayerDimensions?: boolean;
            src?: string;
            type?: string;
            withCredential?: boolean;
        };
    };

    on?(event?: string, handler?: (e: Event) => void): void;

    xhr?: {
        beforeRequest(request?: any): void;
    };

    get bandwidth(): number {
        return this._bandwidth;
    }

    set bandwidth(bandwidth: number) {
        this._bandwidth = bandwidth;
    }

    get systemBandwidth(): number {
        return this._systemBandwidth;
    }

    set systemBandwidth(systemBandwidth: number) {
        this._systemBandwidth = systemBandwidth;
    }

    get throughput(): number {
        return this._throughput;
    }

    set throughput(throughput: number) {
        this._throughput = throughput;
    }

    get selectedPlaylist(): MediaItem {
        return this._selectedPlaylist;
    }

    set selectedPlaylist(selectedPlaylist: MediaItem) {
        this._selectedPlaylist = selectedPlaylist;
    }
}
